import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";

import { $searchUserQuery, $searchUsers } from "../../internal/document/sharing/searchusers.atom";

export const useSearchUserQuery = () => {
	const searchUsersAtom = $searchUsers;
	const loadableSearchUsers = useAtomValue(loadable(searchUsersAtom));
	const setQuery = useSetAtom($searchUserQuery.$debouncedValueAtom);
	const query = useAtomValue($searchUserQuery.$currentValueAtom);

	return {
		query,
		setQuery,
		users: loadableSearchUsers.state === "hasData" ? loadableSearchUsers.data.users : [],
		isLoading:
			loadableSearchUsers.state === "loading" ||
			(loadableSearchUsers.state === "hasData" && loadableSearchUsers.data.isDebouncing),
	};
};
